import { render, staticRenderFns } from "./OutcomeOrsStep.vue?vue&type=template&id=32d343f6"
import script from "./OutcomeOrsStep.vue?vue&type=script&lang=js"
export * from "./OutcomeOrsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports